module.exports = __webpack_public_path__ + "static/media/how-to-use-aligners-poster.a33aad93.jpg";